import { render, staticRenderFns } from "./qaLayout.vue?vue&type=template&id=6ef45e1c&"
import script from "./qaLayout.vue?vue&type=script&lang=js&"
export * from "./qaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef45e1c')) {
      api.createRecord('6ef45e1c', component.options)
    } else {
      api.reload('6ef45e1c', component.options)
    }
    module.hot.accept("./qaLayout.vue?vue&type=template&id=6ef45e1c&", function () {
      api.rerender('6ef45e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qaLayout.vue"
export default component.exports